export const DEFAULT_RECEITA_CATEGORIES = [
  'Salário',
  'Aposentadoria',
  'Aluguel',
  '13º Salário',
  'Pensão',
  'Rendimento',
  'Outros',
];

export const DEFAULT_DESPESA_CATEGORIES = [
  'Moradia',
  'Alimentação',
  'Saúde',
  'Transporte',
  'Energia',
  'Água',
  'Internet',
  'Telefone',
  'Cartão de Crédito',
  'Plano de Saúde',
  'Remédios',
  'Lazer',
  'Vestuário',
  'Educação',
  'Dízimo',
  'Presente',
  'Empréstimo',
  'IPTU',
  'IPVA',
  'Condomínio',
  'Faxineira',
  'Outros',
];
